import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from "recharts";

const sellingPlansData = [
  { name: "Carmozyme", value: 35 },
  { name: "Analgesic", value: 25 },
  { name: "Antibiotic", value: 20 },
  { name: "Ayurvedic", value: 20 }
];

const COLORS = ["#1976d2", "#9c27b0", "#ff9800", "#f44336"];

export default function SellingPlansChart() {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">

        <h6 className="card-title fw-bold mb-3">
          Total Selling Plans
        </h6>

        <div className="d-flex align-items-center">

          {/* Donut Chart */}
          <div style={{ width: "160px", height: "160px" }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={sellingPlansData}
                  innerRadius={50}
                  outerRadius={70}
                  paddingAngle={2}
                  dataKey="value"
                >
                  {sellingPlansData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Legend */}
          <div className="flex-grow-1 ps-3">

            {sellingPlansData.map((item, index) => (
              <div
                key={index}
                className="d-flex align-items-center mb-2"
              >

                <span
                  style={{
                    width: 10,
                    height: 10,
                    backgroundColor: COLORS[index],
                    borderRadius: "50%",
                    marginRight: 8
                  }}
                ></span>

                <small className="text-muted fw-bold">
                  {item.name}
                </small>

              </div>
            ))}

          </div>

        </div>

      </div>
    </div>
  );
}